import React, { useEffect, useState } from "react";
import ProfileNavigationBar from "../../components/profileNavBar";
import GetBadgeComponent from "../../components/GetBadgeComponent";
import { inject, observer } from "mobx-react";
import styles from "./profile.module.scss";
import MainInfo from "../../components/newProfile/mainInfo/mainInfo";
import Bonuses from "../../components/newProfile/bonuses/bonuses";
import PlaningDonation from "../../components/newProfile/planingDonation/PlaningDonation";
import Donations from "../../components/newProfile/donations/Donations";
import DonorPath from "../../components/newProfile/donorPath/DonorPath";
import Banners from "../../components/newProfile/banners/banners";
import Event from "../../components/newProfile/event/Event";
import Trigger from "../../components/newProfile/trigger/Trigger";
import Popup from "../../components/popup/Popup";
import getCookie from "../../hooks/getCookie";
import TriggerPopup from "../../components/newProfile/triggerPopup";
import router, { useRouter } from "next/router";
import InAppStory from "../../components/stories/InAppStory";

const Profile = (props) => {
  const { authStore, newHonorStore, donationsBeforeRegStore, uiStore, triggerStore } = props;
  const { user } = authStore;
  const router = useRouter();
  const { inactive_email } = router.query;
  const CountDonationsPopup = getCookie("CountDonationsPopup");
  const [visibleInfo, setVisibleInfo] = useState(true);
  const [isLaptop, setIsLaptop] = useState(false);
  const [donorPathLoader, setDonorPathLoader] = useState(true);
  const [honor, setHonor] = useState({
    current_blood: null,
    current_plasma: null,
    current_sum: null,
    date: "",
    left: null,
    state: "",
  });
  const [isPopup, setIsPopup] = useState(true);
  const [isTriggerPopup, setIsTriggerPopup] = useState(false);
  const [triggerInfo, setTriggerInfo] = useState({ type: "" });
  const [donationsBeforeReg, setDonationsBeforeReg] = useState<number>(0);

  const getDonorCard = () => {
    donationsBeforeRegStore
      .getCountDonations()
      .then((res) => setDonationsBeforeReg(res.donations_before_reg))
      .catch((err) => console.log(err));
  };

  const getCountOfVisits = () => {
    authStore.getCountOfVisits();
  };

  const getHonor = () => {
    newHonorStore.load().then((res) => {
      setDonorPathLoader(false);
      setHonor(res);
    });
  };

  useEffect(() => {
    getHonor();
    getCountOfVisits();
    getDonorCard();
    if (Boolean(inactive_email)) {
      setIsTriggerPopup(true)
    } else {
      triggerStore.loadPopupTrigger().then((res) => {
        setIsTriggerPopup(res.type === "email_inactive")
      })
    }
  }, []);

  useEffect(() => {
    uiStore.setActiveTab(0);
  }, []);

  const handleResize = () => {
    const width = window.innerWidth;
    if (width >= 769) {
      setIsLaptop(true);
    } else {
      setIsLaptop(false);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const rectangle =
    ((honor?.current_blood > 0 && honor?.current_plasma > 0) ||
      (honor?.current_blood === 0 && honor?.current_plasma === 0)) &&
    honor.state !== "done" &&
    !user?.donor_certificate;

  const isDonat = triggerInfo?.type === "all_filled";

  return (
    <>
      {isPopup && donationsBeforeReg === null && !CountDonationsPopup && (
        <Popup
          dateJoined={user?.date_joined}
          setIsPopup={setIsPopup}
          setTriggerInfo={setTriggerInfo}
        />
      )}
      {
        isTriggerPopup && (
          <TriggerPopup
            setIsPopup={setIsTriggerPopup}
          />
        )
      }
      <div>
        <ProfileNavigationBar />
        <GetBadgeComponent currentUser={user} />
        <div className={isLaptop ? "container" : ""}>
          <div className={styles.ProfileDesktop}>
            <div
              className={`${styles.Block1} ${isDonat && styles.Block1WithDonat
                }`}
            >
              <MainInfo
                honor={honor}
                user={user}
                visibleInfo={visibleInfo}
                setVisibleInfo={setVisibleInfo}
                isLaptop={isLaptop}
              />
            </div>
            <div
              className={`${styles.Block2} ${isDonat && styles.Block2WithDonat
                }`}
            >
              <Trigger
                triggerInfo={triggerInfo}
                setTriggerInfo={setTriggerInfo}
              />
            </div>
            <div
              className={`${styles.Block3} ${isDonat && styles.Block3WithDonat
                }`}
            >
              <PlaningDonation />
            </div>
            <div
              className={`${styles.Block4} ${isDonat && styles.Block4WithDonat
                }`}
            >
              <Bonuses />
            </div>
            <div
              className={`${styles.Block5} ${isDonat && styles.Block5WithDonat
                }`}
            >
              <Event />
            </div>
            <div
              className={`${styles.Block6} ${isDonat && styles.Block6WithDonat
                } ${rectangle && styles.Block6Long}`}
            >
              <DonorPath donorPathLoader={donorPathLoader} honor={honor} />
            </div>
            <div
              className={`${styles.Block7} ${isDonat && styles.Block7WithDonat
                } ${rectangle && styles.Block7Right}`}
            >
              <Banners rectangle={rectangle} />
            </div>
            <div
              className={`${styles.Block8} ${isDonat && styles.Block8WithDonat
                }`}
            >
              <Donations />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default inject(
  "authStore",
  "newHonorStore",
  "donationsBeforeRegStore",
  "uiStore",
  "triggerStore"
)(observer(Profile));
